import { Endpoints, fetcher } from './utils';
import type {
  DetermineAuthActionRequest,
  DetermineAuthActionResponse,
  TenantLookupResponse,
} from '../shared/types';

export async function lookupTenant(
  userEmail: string,
  workflowId?: string,
): Promise<TenantLookupResponse> {
  return fetcher(Endpoints.TENANT_LOOKUP_BY_DOMAIN, {
    method: 'POST',
    body: JSON.stringify({ userEmail }),
    workflowId,
  });
}

export async function determineAuthMethod(
  request: DetermineAuthActionRequest,
  tenantId: string,
  workflowId?: string,
): Promise<DetermineAuthActionResponse> {
  return fetcher(
    Endpoints.AUTH_ACTION_DETERMINE,
    {
      method: 'POST',
      body: JSON.stringify(request),
      workflowId,
    },
    tenantId,
  );
}

export async function createClientUserSession(
  tenantId: string,
  workflowId?: string,
) {
  return fetcher(
    Endpoints.CREATE_CLIENT_USER_SESSION,
    {
      method: 'POST',
      workflowId,
    },
    tenantId,
  );
}
